/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  .fill {
    fill: ${theme.color.themeTxt};
  }
`

export default class GoTopIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14.459" height="16.751" viewBox="0 0 14.459 16.751" css={Color}>
        <g id="그룹_6923" data-name="그룹 6923" transform="translate(-5287 -9810)">
          <path id="패스_6323" className="fill" data-name="패스 6323" d="M390.523,245.626a.747.747,0,0,1-.53-.219l-5.95-5.95-5.95,5.95a.75.75,0,0,1-1.06-1.061l6.48-6.48a.749.749,0,0,1,1.06,0l6.48,6.48a.75.75,0,0,1-.53,1.28Z" transform="translate(4910.187 9572.354)" fill="#eee"/>
          <path id="패스_6324" data-name="패스 6324" d="M384.043,238.4h0a.75.75,0,0,1,.75.75v14.5a.75.75,0,0,1-.75.75h0a.75.75,0,0,1-.75-.75v-14.5A.75.75,0,0,1,384.043,238.4Z" transform="translate(4910.187 9572.354)" fill="none"/>
          <path id="패스_6325" className="fill" data-name="패스 6325" d="M384.043,254.4a.75.75,0,0,1-.75-.75v-14.5a.75.75,0,0,1,1.5,0v14.5A.75.75,0,0,1,384.043,254.4Z" transform="translate(4910.187 9572.354)" fill="#eee"/>
        </g>
      </svg>
    )
  }
}
